import { EuiSpacer } from '@elastic/eui';
import SuccessBox from 'components/Web_User_Interface/1080p_Series/System/Update/SuccessBox';
import YoutubeVideo from 'components/Web_User_Interface/1080p_Series/System/Update/VideoInstarVision';
import UpdateTable from 'components/Web_User_Interface/1080p_Series/System/Update/updateTable';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  EuiSpacer,
  SuccessBox,
  YoutubeVideo,
  UpdateTable,
  BreadCrumbs,
  SEOHelmet,
  React
};